import moment from 'moment'

export default {
    filters: {

        converteHora(hora) {

            if(!hora) return ''
            return hora.slice(0, -3)

        },

        converteDataHora(dataHora) {

            if (!dataHora) return;
            return moment(dataHora).format('DD/MM/YYYY HH:mm');

        },

        converteData(data) {

            if (!data) return;
            return moment(data).format('DD/MM/YYYY');

        },

    }
}